import { useContext } from "react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { AxiosContext } from "contexts/AxiosContext";
import { CaseLink } from "interfaces/case-links";
import { makeQueryString } from "core/makeQueryString";
import { PaginatedResponse } from "interfaces/utils";

const STALE_TIME = 1000 * 60 * 15;

interface CommonArgs {
  ordering?: string;
  page?: number;
  search?: string;
  size?: number;
  enabled?: boolean;
}

interface CaseLinksQueryArgs extends CommonArgs {
  case?: string; // should be number?
}

export const useCaseLinksQuery = (
  args: CaseLinksQueryArgs = {}
): UseQueryResult<PaginatedResponse<CaseLink[]>, unknown> => {
  const { axios } = useContext(AxiosContext)!;

  const { enabled: isEnabled, ...qsArgs } = args;
  const enabled = isEnabled ?? true;

  const qs = makeQueryString(qsArgs);

  return useQuery({
    queryKey: ["case", "links", args ? args : "all"],
    queryFn: async () => {
      const { data } = await axios.get<PaginatedResponse<CaseLink[]>>(
        `/case_links${qs}`
      );

      return data;
    },
    staleTime: STALE_TIME,
    enabled
  });
};
